import { ABEventList } from '../lib/ab/event';
import { ABScreen } from '../lib/ab/screen';
import { aTrackPage } from '../lib/mdl/a-track';
import { cCityBySlug } from '../lib/mdl/c-city';
import { chEventListActiveByVenueSlug } from '../lib/mdl/c-event-home';
import { $el } from '../lib/ui/elements';
import { UIViewSpec } from '../lib/ui/view';
import { HomeMenu } from './menu';

export class HomeVenueScreen extends ABScreen {
    constructor(private _city_slug: string, private _slug: string) {
        super({ menu: new HomeMenu });
    }

    protected override async fillContent(content: UIViewSpec) {
        const city = cCityBySlug(this._city_slug)!;
        let { venue, events } = await chEventListActiveByVenueSlug(city.id, this._slug);

        content.ui_add($el.SECTION('w-block', [
            $el.P('bigtitle', venue.name),
            new ABEventList('venue', 'list', 'event', events, { filter: 'active', sort: 'date' })
        ]));

        aTrackPage('venue', { venue: venue.id });
    }
}
